import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

type ApplicationBehaviorData = {
  infrastructure: {
    requiresVpn: boolean | null;
    requiresIpWhitelist: boolean | null;
    cloudProvider: string | null;
    techStack: string[];
  };
  authentication: {
    mechanisms: string[];
  };
  outOfScope: string[];
};

export function useApplicationBehavior(applicationId: string) {
  return useQuery({
    queryKey: ['application-behavior', applicationId],
    queryFn: async (): Promise<ApplicationBehaviorData | null> => {
      const scopingData =
        await terraProxyApiClient.getApplicationScoping(applicationId);

      if (!scopingData) {
        return null;
      }

      const techStack: string[] = [];
      if (scopingData.fileScopingData) {
        if (scopingData.fileScopingData.serverSideLanguage) {
          techStack.push(scopingData.fileScopingData.serverSideLanguage);
        }
        techStack.push(
          ...(scopingData.fileScopingData.clientSideTechnologies || []),
        );
        techStack.push(...(scopingData.fileScopingData.databases || []));
      }

      return {
        infrastructure: {
          requiresVpn: scopingData.requiresVpn ?? null,
          requiresIpWhitelist: scopingData.requiresIpWhitelist ?? null,
          cloudProvider: scopingData.cloudProvider ?? null,
          techStack,
        },
        authentication: {
          mechanisms: scopingData.authenticationMechanisms || [],
        },
        outOfScope: scopingData.outOfScopeFeatures || [],
      };
    },
    enabled: !!applicationId,
    staleTime: 60000,
  });
}
